import { useState } from "react";
import type RealtimeKitClient from "@cloudflare/realtimekit";
import { MicOff } from "lucide-react";

type MuteAllShortcutProps = {
  meeting: RealtimeKitClient | null;
  className?: string;
};

/**
 * Atalho visual para a função que já existe: participants.disableAllAudio.
 * Não altera o botão original da videochamada.
 */
const MuteAllShortcut = ({ meeting, className = "" }: MuteAllShortcutProps) => {
  const [busy, setBusy] = useState(false);
  if (!meeting) {
    return null;
  }

  const muteAll = () => {
    if (busy) {
      return;
    }
    const participants = meeting.participants as {
      disableAllAudio?: (allowUnmute?: boolean) => Promise<void> | void;
    };
    if (typeof participants.disableAllAudio !== "function") {
      return;
    }
    setBusy(true);
    void Promise.resolve(participants.disableAllAudio(true))
      .catch(() => undefined)
      .finally(() => setBusy(false));
  };

  return (
    <button
      type="button"
      onClick={muteAll}
      disabled={busy}
      title="Silenciar todos"
      aria-label="Silenciar todos"
      className={`flex touch-manipulation items-center gap-1.5 rounded-full bg-gray-900/90 px-3 py-2 text-xs font-semibold text-white shadow-lg backdrop-blur-sm border border-gray-700/50 hover:bg-gray-800 disabled:opacity-60 ${className}`}
    >
      <MicOff className="h-3.5 w-3.5 shrink-0 text-blue-300" aria-hidden />
      Todos
    </button>
  );
};

export default MuteAllShortcut;
